import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import Dashboard from "../admin/Dashboard";
import Sidebar from "../admin/Sidebar";
import Header from "../admin/TopHeader";
import Add from "../admin/setting/Add";
import Productlist from "../admin/products/ListProduct";
import Productadd from "../admin/products/AddProduct";
import ProductEdit from "../admin/products/EditProduct";
import ProductView from "../admin/products/ViewProduct";
import Adduser from "../admin/user/Adduser";
import ListCategory from "../admin/Category/ListCategory";
import Subcategory from "../admin/subcategory/List";
import Color from "../admin/color/List";
import Size from "../admin/size/List";

import Order from "../admin/order/OrderList";
import OrderView from "../admin/order/OrderDetails";

// ✅ NEW: Manual Order pages — create these components when ready
// import ManualOrderCreate from "../admin/order/ManualOrderCreate";
// import ManualOrderList   from "../admin/order/ManualOrderList";

import Lable from "../admin/label/Label";
import Banner from "./banner/Banner";
import Coupons from "./couponlist/Couponlist";
import ProtectedLayout from "../admin/component/ProtectedLayout";
import Permissions from "../admin/setting/ManagePermissions";
import ManualOrderCreate from "../admin/order/ManualOrderCreate";
import ManualOrderList   from "../admin/order/ManualOrderList";
import { loadCSS, loadJS, removeAssets } from "../../utils/loadAssets";

const AdminApp = () => {

  useEffect(() => {
    loadCSS("/assets/css/vendor.min.css");
    loadCSS("/assets/css/icons.min.css");
    loadCSS("/assets/css/app.min.css");
    loadCSS("/assets/css/style.css");
    loadCSS("/assets/css/coloreditor.css");
    loadJS("/assets/js/config.js");
    loadJS("/assets/js/vendor.js");
    loadJS("/assets/js/app.js");
  }, []);

  return (
    <ProtectedLayout>
      <div className="wrapper">

        <Header />

        <div className="main-nav">
          <Sidebar />
        </div>

        <div className="page-content">
          <div className="container-fluid">

            <Routes>
              <Route path="/dashboard"          element={<Dashboard />} />
              <Route path="/setting/add"         element={<Add />} />
              <Route path="/product/list"        element={<Productlist />} />
              <Route path="/product/add"         element={<Productadd />} />
              <Route path="/products/edit/:id"   element={<ProductEdit />} />
              <Route path="/products/view/:id"   element={<ProductView />} />
              <Route path="/user/adduser"        element={<Adduser />} />
              <Route path="/category/list"       element={<ListCategory />} />
              <Route path="/subcategory/list"    element={<Subcategory />} />
              <Route path="/color/list"          element={<Color />} />
              <Route path="/size/list"           element={<Size />} />
              <Route path="/label/list"          element={<Lable />} />
              <Route path="/banner/list"         element={<Banner />} />

              {/* Order tabs */}
              <Route path="/order/Received"   element={<Order statusFilter="placed" />} />
              <Route path="/order/Processing" element={<Order statusFilter="processing" />} />
              <Route path="/order/Printing"   element={<Order statusFilter="printing" />} />
              <Route path="/order/hold"       element={<Order statusFilter="hold" />} />
              <Route path="/order/Shipped"    element={<Order statusFilter="shipped" />} />
              <Route path="/order/Delivered"  element={<Order statusFilter="delivered" />} />
              <Route path="/order/view/:id"   element={<OrderView />} />
<Route path="/manual-order/create"   element={<ManualOrderCreate />} />
<Route path="/manual-order/edit/:id" element={<ManualOrderCreate />} />
<Route path="/manual-order/list"     element={<ManualOrderList />} />
              {/* ✅ NEW: Manual Order routes
                  Uncomment the imports above and replace the placeholder divs
                  with your actual components once you build them */}
              <Route
                path="/manual-order/create"
                element={
                  <div className="p-4">
                    <h4>Manual Order — Create</h4>
                    <p className="text-muted">Build your ManualOrderCreate component and import it here.</p>
                  </div>
                }
              />
              <Route
                path="/manual-order/list"
                element={
                  <div className="p-4">
                    <h4>Manual Order — List</h4>
                    <p className="text-muted">Build your ManualOrderList component and import it here.</p>
                  </div>
                }
              />

              <Route path="/coupon/list"         element={<Coupons />} />
              <Route path="/user/permissions"    element={<Permissions />} />
            </Routes>

          </div>

          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 text-center">
                  © 2016 Copyright by&nbsp;
                  <a href="#" className="fw-bold footer-text" target="_blank" rel="noreferrer">
                    ShaArt
                  </a>
                </div>
              </div>
            </div>
          </footer>

        </div>
      </div>
    </ProtectedLayout>
  );
};

export default AdminApp;